export const getFilteredData = (data, search, activeTab) => {
  const searchStr = search.toLowerCase();
  return data.filter((item) => {
    if (activeTab === "supplier") {
      const vendorName = item.name || item.vendorName || "";
      const vendorCode = item.code || item.vendorCode || "";
      return (
        vendorName.toLowerCase().includes(searchStr) ||
        (item.mobile || "").includes(searchStr) ||
        vendorCode.toLowerCase().includes(searchStr)
      );
    } else if (activeTab === "registeredType") {
      const itemTitle = item.title || item.registeredTypeName || "";
      const itemCode = item.code || item.registeredTypeCode || "";
      return (
        itemTitle.toLowerCase().includes(searchStr) ||
        itemCode.toLowerCase().includes(searchStr) ||
        (item.description?.toLowerCase() || "").includes(searchStr)
      );
    } else if (activeTab === "item") {
      const categoryStr = item.category?.title || "";
      const brandStr = item.brand?.title || "";
      return (
        (item.itemName?.toLowerCase() || "").includes(searchStr) ||
        (item.itemCode?.toLowerCase() || "").includes(searchStr) ||
        categoryStr.toLowerCase().includes(searchStr) ||
        brandStr.toLowerCase().includes(searchStr) ||
        (item.createdAt || item.createdDate || item.created
          ? new Date(item.createdAt || item.createdDate || item.created).toLocaleDateString().includes(searchStr)
          : false)
      );
    } else if (activeTab === "stores") {
      const storeTitle = item.title || item.storeName || "";
      const storeCode = item.code || item.storeCode || "";
      return (
        storeTitle.toLowerCase().includes(searchStr) ||
        storeCode.toLowerCase().includes(searchStr) ||
        (item.address?.toLowerCase() || "").includes(searchStr) ||
        (item.mobile || "").includes(searchStr) ||
        (item.createdAt || item.createdDate || item.created
          ? new Date(item.createdAt || item.createdDate || item.created).toLocaleDateString().includes(searchStr)
          : false)
      );
    } else if (activeTab === "purchase") {
      const vendorStr =
        typeof item.vendor === "object"
          ? item.vendor?.name || item.vendor?.title || ""
          : "";
      return (
        (item.billNo?.toLowerCase() || "").includes(searchStr) ||
        vendorStr.toLowerCase().includes(searchStr)
      );
    }
    
    const itemTitle = item.title || item.unitName || item.brandName || item.categoryName || "";
    const itemCode = item.code || item.unitCode || item.brandCode || item.categoryCode || "";
    return (
      itemTitle.toLowerCase().includes(searchStr) ||
      itemCode.toLowerCase().includes(searchStr) ||
      (item.createdAt || item.createdDate || item.created
        ? new Date(item.createdAt || item.createdDate || item.created).toLocaleDateString().includes(searchStr)
        : false)
    );
  });
};
